"use client";

import { LogCard } from "@/components/dashboard/log-card";
import { getFeatureDemoCopy } from "@/components/features/feature-demo-copy";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/lib/components/card";
import { mockLogs } from "@/lib/mock-feature-data";

import { useI18n } from "@llmgateway/i18n/react";

export function ActivityLogsDemo() {
	const { locale } = useI18n();
	const copy = getFeatureDemoCopy(locale).activityLogs;
	const logs = mockLogs.map((log, index) => ({
		...log,
		content: copy.logs[index] ?? log.content,
		errorDetails: log.errorDetails
			? {
					...log.errorDetails,
					statusText: copy.error.statusText,
					responseText: copy.error.responseText,
				}
			: log.errorDetails,
	}));

	return (
		<Card>
			<CardHeader>
				<CardTitle>{copy.title}</CardTitle>
				<CardDescription>{copy.description}</CardDescription>
			</CardHeader>
			<CardContent>
				<div className="space-y-4">
					{logs.map((log) => (
						<LogCard key={log.id} log={log} />
					))}
				</div>
			</CardContent>
		</Card>
	);
}
